import * as SockJS from 'sockjs-client'
import * as StompJS from 'webstomp-client'

const ENTRY_POINT = '/ezvalue-socket'

export default class WebSocketService {
  sockJS: any
  stompJS: any
  subscriptions: any[]

  initialize() {
    this.sockJS = new SockJS(ENTRY_POINT)
    this.stompJS = StompJS.over(this.sockJS)
    // disable debug log message, comment below statement in development phase
    this.stompJS.debug = () => ''
    this.subscriptions = []
  }

  async connect(onSuccessCallback: ICallback, onError: ICallback) {
    const onSuccess = () => {
      if (this.stompJS.connected) {
        onSuccessCallback()
      }
    }

    await this.stompJS.connect({}, onSuccess, onError)
  }

  async subscribe(id: string, channel: string, onMessage: ICallback2<IMessage>, onError: ICallback) {
    if (this.stompJS.connected) {

      if (this.subscriptions.find(subscriber => subscriber.id === id)) {
        return
      }

      const subscription = this.stompJS.subscribe(channel, onMessage, onError)
      this.subscriptions.push({ id, channel, subscription })
    } else {
      // retry to subscribe after 1s
      await setTimeout(() => this.subscribe(id, channel, onMessage, onError), 1000)
    }
  }

  unsubscribe(id: string) {
    let index = this.subscriptions.findIndex(subscriber => subscriber.id === id)

    if (this.stompJS.connected && index !== -1) {
      const subscriber = this.subscriptions[index]
      subscriber.subscription.unsubscribe()

      this.subscriptions.splice(index, 1)
    }
  }

  disconnect() {
    if (this.stompJS.connected) {
      this.stompJS.disconnect()
    }
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/services/WebSocketService.ts